/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

type CloseIconV2Props = ComponentPropsWithoutRef<'svg'>;

function CloseIconV2(props: CloseIconV2Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      {...props}
    >
      <path
        d="M9.24586 9.88649L5.05469 5.69531M9.24586 9.88649L5.05469 14.0777M9.24586 9.88649L13.437 5.69531M9.24586 9.88649L13.437 14.0777"
        stroke="#1D1D1D"
        strokeWidth="1.39706"
        strokeLinecap="square"
      />
    </svg>
  );
}

export default memo(CloseIconV2);
